import { useLocalStorage } from "usehooks-ts";
import { COERCED_VIDEO_PLATFORM_KEY } from "../config";
import { VideoPlatform } from "../video-sdk";

/**
 * Hook to manage a coerced video platform stored in localStorage.
 * When set, this overrides the Statsig-determined video platform.
 * Used to align the provider's video platform with the client's platform when there's a mismatch.
 */
export function useCoercedVideoPlatform() {
  return useLocalStorage<VideoPlatform | null>(
    COERCED_VIDEO_PLATFORM_KEY,
    null,
  );
}
